import { render, staticRenderFns } from "./AnnouncementForm.vue?vue&type=template&id=0791be19&scoped=true"
import script from "./AnnouncementForm.vue?vue&type=script&lang=ts"
export * from "./AnnouncementForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0791be19",
  null
  
)

export default component.exports